import React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';
import ELEMENTS from '~/components/PluginsEditor/components/elements/elementsEnum';
import { ParagraphElement } from '~/components/PluginsEditor/types';
import serialize from './serialize';

export type Props = RenderElementProps & {
  dataTestId?: string;
  element: ParagraphElement;
};

const Paragraph: React.FC<Props> = ({
  dataTestId,
  attributes,
  element,
  children,
}) => (
  <Container data-testid={dataTestId} {...attributes} {...element.attributes}>
    {children}
  </Container>
);

const Container = styled.p<{}>``;

export default {
  nodeName: 'P',
  renderComponent: props => <Paragraph {...props} />,
  deserialize: () => ({
    type: ELEMENTS.PARAGRAPH,
  }),
  serialize,
};
